"use strict";
exports.__esModule = true;
//# sourceMappingURL=bulle-talk.js.map